
export type ChatMessage = {
  id: string | number;
  role: string;
  content: string;
};

export type AvailableToolsListType = {
  name: string;
  description: string;
};

export const PAGE_NAME_OPTIONS = [
  'websites-list',
  'site-collections',
  'trash',
  'domains-list',
  'referrals',
  'statistics',
  'general-info',
  'domains',
  "forms",
  'ecommerce',
  'blog',
  'multilingual',
  'crm',
  'social-links',
  'cookie-banner',
  'analytics',
  'integrations',
  'chat',
  'custom-code',
  'contributors',
  'subscription',
  'editor'
] as const;

export type PageNameOption = typeof PAGE_NAME_OPTIONS[number];

export type SessionContextType = {
  websiteId: string | null;
  pageName: PageNameOption | '' | null;
};

export type SessionSummary = {
  text: string;
  timestamp: string;
};

export type SessionRenameOptions = {
  timestamp: string;
  userMessagesUsed: number;
  regenerationCount: number;
};

export type SessionUsageInfo = {
  limitClass: string;
  messagesUsed: number;
  messagesRemaining: number;
  maxMessages: number;
  inputTokensUsed: number;
  inputTokensRemaining: number;
  maxInputTokens: number;
  outputTokensUsed: number;
  outputTokensRemaining: number;
  maxOutputTokens: number;
};

export type ChatCompletionResponse = {
  status: 'OK' | 'Error';

  // messages: {
  //   role: string;
  //   content: string;
  // }[];

  lastToolsCalls: completionFunctionalToolsCallsLogType[];

  totalTokens: number;
  lastReply: {
    id: string;
    role: 'user' | 'assistant' | 'tool';
    content: string;
    timestamp: string;
    duration: number;
    is_liked: boolean;
    is_disliked: boolean;
  };

  isConversationEnded: boolean;
  result: object;
};

export type completionFunctionalToolsCallsLogType = {
  id: string;
  name: string;
  arguments: string;
  result: string;
};

// Sessions types
export type SessionListItem = {
  id: string;
  name: string;
  is_active: boolean;
  is_ended: boolean;
  created_at: string;
  updated_at: string;
  language?: string;
};

export type SessionsListResponse = {
  status: 'OK';
  sessions: SessionListItem[];
};

export type CreateSessionResponse = {
  status: 'OK';
  message: string;
  session: {
    id: string;
    name: string;
    language?: string;
  };
};

export type GetSessionResponse = {
  status: 'OK';
  session: {
    id: string;
    name: string;
    language?: string;
    current_context: SessionContextType | null;
    context_history: SessionContextType[];
    messages: {
      id: string;
      role: 'user' | 'assistant' | 'tool';
      content: string;
      timestamp: string;
      duration: number;
      is_liked: boolean;
      is_disliked: boolean;
    }[];
    tools: string[];
    totalTokens: number;
    summary: SessionSummary | null;
    renameOptions: SessionRenameOptions | null;
    usage: SessionUsageInfo | null;
    is_active: boolean;
    is_ended: boolean;
    is_deleted: boolean;
    created_at: string;
    updated_at: string;
  };
  lastToolsCalls: completionFunctionalToolsCallsLogType[];
  lastReply: {
    role: string;
    content: string;
    suggestions: {
      type: 'multiChoice' | 'singleChoice' | '';
      options: string[];
    };
    isConversationEnded: boolean;
  };
};
